import { toNIfFalsy } from "@agrigate/ts-utils/lib/coercions";
import type {
    BoxProps,
    FieldErrorTextProps,
    FieldHelperTextProps,
    FieldLabelProps,
    FieldRootProps,
} from "@chakra-ui/react";
import { Box, Field } from "@chakra-ui/react";
import type { PropsWithChildren } from "react";

export default function FormItem(
    p: PropsWithChildren<
        {
            label?: string;
            required?: boolean;
            variant?: "solo";
            details?: string[];
            display?: string;
            error?: boolean | string[];
            labelProps?: FieldLabelProps;
            helperTextProps?: FieldHelperTextProps;
            formControlProps?: FieldRootProps;
            errorMessage?: string;
            fieldNote?: string;
            errorTextProps?: FieldErrorTextProps;
        } & BoxProps
    >,
) {
    const {
        label,
        required,
        fieldNote,
        details,
        labelProps,
        helperTextProps,
        formControlProps,
        errorMessage,
        errorTextProps,
        ...restProps
    } = p;
    return (
        <Field.Root
            {...formControlProps}
            {...restProps}
            required={required}
            invalid={!!errorMessage}
            color={p.error ? "var(--chakra-colors-red-solid)" : undefined}
        >
            {p.label && (
                <Field.Label
                    fontSize={"xs"}
                    fontWeight={p.variant === "solo" ? "bold" : undefined}
                    {...labelProps}
                >
                    {p.label}
                    <Field.RequiredIndicator />
                    {fieldNote ? `(${fieldNote})` : null}
                </Field.Label>
            )}
            {p.children}
            {errorMessage && (
                <Field.ErrorText {...errorTextProps}>
                    {errorMessage}
                </Field.ErrorText>
            )}
            {toNIfFalsy(p.details) && (
                <Field.HelperText {...helperTextProps}>
                    <Box as="ul" pl={4}>
                        {p.details?.map(detail => (
                            <li key={detail}>{detail}</li>
                        ))}
                    </Box>
                </Field.HelperText>
            )}
        </Field.Root>
    );
}
